import { z } from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";
import { intl } from "LocaleWrapper";

export const callCreateOrEditSchema = z.object({
	id: z.number().nullable(),
	location: ZodSchema.requiredField(locationSelectOptionSchema),
	pta: ZodSchema.requiredField(z.number()),
	ptd: ZodSchema.requiredField(z.number()),
}).refine(data => data.pta <= data.ptd, {
	message: intl.formatMessage({ id: "PTD_BEFORE_PTA" }),
	path: [ "ptd" ],
	when(payload) {
		return callCreateOrEditSchema.pick({ pta: true, ptd: true }).safeParse(payload.value).success;
	},
});

export type CallCreateOrEditSchemaInput = z.input<typeof callCreateOrEditSchema>;
export type CallCreateOrEditSchemaOutput = z.output<typeof callCreateOrEditSchema>;

export const updateCallPtaSchema = z.object({
	pta: ZodSchema.requiredField(z.number()),
});

export type UpdateCallPtaSchemaInput = z.input<typeof updateCallPtaSchema>;
export type UpdateCallPtaSchemaOutput = z.output<typeof updateCallPtaSchema>;

export const updateCallLocationSchema = z.object({
	location: ZodSchema.requiredField(locationSelectOptionSchema),
});

export type UpdateCallLocationSchemaInput = z.input<typeof updateCallLocationSchema>;
export type UpdateCallLocationSchemaOutput = z.output<typeof updateCallLocationSchema>;
